<template>
  <div class="container">
    <div class="signature-image-wrapper">
      <img
        :src="signatureImageUrl"
        alt=""
      />
    </div>

    <div class="actions">
      <div>
        <el-button
          v-if="isEditable"
          type="default"
          @click="onClickRewrite"
        >
          書き直す
        </el-button>
      </div>

      <div>
        <el-button
          @click="onClickClose"
        >
          閉じる
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonMySignatureViewer",
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    signatureImageUrl: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
    };
  },
  created () {
  },
  async mounted () {
  },
  methods: {
    /**
     * [onClickRewrite description]
     * @return  {[type]}  [return description]
     */
    onClickRewrite () {
      this.$emit("onRewrite");
    },

    /**
     * [onClickClose description]
     * @return  {[type]}  [return description]
     */
    onClickClose () {
      this.$emit("onClose");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.signature-image-wrapper {
  height: 300px;
  width: 860px;
}

.actions {
  padding: 10px 0;
  text-align: right;
  display: flex;
  justify-content: space-between;
}
</style>
